/**
 * Copyright (c) 2017 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import { QueryContext } from './context';
var StructureQuery;

(function (StructureQuery) {
  function run(query, structure, options) {
    return query(new QueryContext(structure, options));
  }

  StructureQuery.run = run;
})(StructureQuery || (StructureQuery = {}));

export { StructureQuery };